import styled from "styled-components";

export const Container = styled.button`
  height: 40px;

  display: flex !important;
  justify-content: center;
  align-items: center;
  padding: 12px 49px;
  border-radius: 5px;

  font-size: 16px;
  line-height: 16px;
  font-weight: bold;
  white-space: nowrap;

  background-color: var(--primary-color);

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  span {
    font-size: 16px;
  }
`;
